import { useEffect, useState, useRef } from 'react';
import { useAuth, useBasic } from 'contexts';
import { actionLog, getCourses, getCertificado, getFolderProgress, getCompletedCourses } from 'services';
import moment from 'moment';
import 'moment/locale/pt-br';

import './style.scss';

moment.locale('pt-br');

type Props = {
  certifield: any[];
  profiles?: string[];
  className?: string;
  courseID?: string;
  [key: string]: any;
};

export function ModalPrintCertificate({ certifield, profiles, className, courseID, ...rest }: Props) {
  const { user } = useAuth();
  const [log, setLog] = useState<any>();
  const [selectedCourse, setSelectedCourse] = useState<string>('');
  const [filteredCourses, setFilteredCourses] = useState<any[]>([]);
  const [courses, setCourses] = useState<any[]>([]);
  const [certificados, setCertificados] = useState<any[]>([]);
  const [selectedCertificado, setSelectedCertificado] = useState<any>(null);
  const initializedRef = useRef(false);

  const loadCertificadoData = async () => {
    try {
      if (!user || !courseID) return;

      // Buscar o certificado pelo courseID
      const certificado = certificados.find(cert => cert.courseId === courseID);
      setSelectedCertificado(certificado || null);

      // Buscar o actionlog do curso
      const response = await getCompletedCourses({}, 'items=0-1000');
      const log = response?.data?.filter((courseComplete: any) => courseID === courseComplete.attributes.course);
      setLog(log[0]);
    } catch (error) {
      console.error('Error fetching certificado data:', error);
    }
  };

  useEffect(() => {
    const loadCertificados = async () => {
      try {
        const certificadosData = await getCertificado(courseID);
        setCertificados(certificadosData);
      } catch (error) {
        console.error('Error fetching certificados:', error);
      }
    };

    if (user) {
      loadCertificados();
    }
  }, [user, courseID]);

  useEffect(() => {
    loadCertificadoData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCourse, certificados]);

  useEffect(() => {
    const modalContents = document.getElementsByClassName('modal-content');
    if (modalContents.length > 0) {
      for (let i = 0; i < modalContents.length; i++) {
        modalContents[i].classList.add('modal-content-print');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const handlePrint = () => {
    window.print();
    actionLog('imprimir_certificado');
  };

  if (!certifield) return null;

  return (
    <section id="print" className={className}>
      <div id="printContent">
        {selectedCertificado && selectedCertificado.image && <img src={selectedCertificado.image.original.url} alt="" />}
        <p className="nome">{user?.name}</p>
        <p className="cpf">{user?.extra.cpf}</p>
        {selectedCertificado && selectedCertificado.title && <p className="certificacao">{selectedCertificado.title}</p>}
        {selectedCertificado && selectedCertificado.cargaHoraria && (
          <p className="cargaHoraria">{selectedCertificado.cargaHoraria}</p>
        )}
        {selectedCertificado && selectedCertificado.baseLegal && <p className="baseLegal">{selectedCertificado.baseLegal}</p>}
        <p className="data">{log && moment(log.time).format('DD/MM/yyyy')}</p>
        <p className="codigo">{log && log._id}</p>
      </div>
      <div className='flex justify-center mt-8'>
        <button onClick={handlePrint} id="btnPrint">
          Imprimir Certificado
        </button>
      </div>
    </section>
  );
}
